import { render, staticRenderFns } from "./AccordoNotes.vue?vue&type=template&id=55afbaf4"
import script from "./AccordoNotes.vue?vue&type=script&lang=js"
export * from "./AccordoNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports